export default __webpack_public_path__ + "static/chair_a-2fabe5728c6c60ccea7317fa41114950.jpg";